import React from 'react';
import ProductModelSpecifications from '../productModelSpecifications';

const ProductSeriesDetailModelSpecifications = (props): JSX.Element | null => {
  return (
    <>
      <ProductModelSpecifications {...props} seriesDetail={true} />
    </>
  );
};

export default ProductSeriesDetailModelSpecifications;
